import { render } from "./FormResult.vue?vue&type=template&id=10aeddd5&scoped=true"
import script from "./FormResult.vue?vue&type=script&lang=js"
export * from "./FormResult.vue?vue&type=script&lang=js"

import "./FormResult.vue?vue&type=style&index=0&id=10aeddd5&scoped=true&lang=css"

import exportComponent from "/builds/shapkin/crm-mentoring.exportedu.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10aeddd5"]])

export default __exports__